module.exports = __webpack_public_path__ + "static/media/1st-spec.f8bfc17e.jpg";